import logRocket from "./logrocket";

export default [logRocket];
